function SectionLabel({ text, variant = 'default' }) {
  return (
    <div className={`section-label section-label--${variant}`}>
      <span className="label-line"></span>
      <span className="label-text">{text}</span>
      <span className="label-line"></span>
    </div>
  );
}

export default SectionLabel;
